import React from 'react';

import { useExternalFolderHeaderSectionQuery } from 'generated/graphql';



export interface IData {
  folderName: string;
  projectAddress: string;
}

export function useQuery(folderId: string) {
  const tuple = useExternalFolderHeaderSectionQuery({
    variables: {
      folderId
    }
  });

  return React.useMemo(() => {
    const folder = tuple.data?.folder;
    const data: IData = {
      folderName: folder?.name ?? '',
      projectAddress: folder?.project.locationAddress.formattedFullAddress ?? ''
    };

    return {
      ...tuple,
      data
    };
  }, [tuple]);
}
